var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":"uploads-diversos"}},[_c('v-card',{staticClass:"py-4 px-2 auth-content",attrs:{"tile":""}},[_c('v-form',{ref:"form"},[_c('PageTitle',{attrs:{"main":"Administração","icon":"mdi-pencil-box-outline","sub":"Uploads de arquivos diversos","home":"/administracao"}}),_c('Cadastro')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }